const drawer = document.getElementById('mobile-menu-drawer');
const openBtn = document.querySelector('.mobile_menu_btn');
const closeBtn = document.querySelector('.mobile_drawer_close');

// Open drawer
openBtn?.addEventListener('click', () => {
    drawer.classList.add('active');
    document.body.style.overflow = "hidden"; // prevent background scroll
});

// Close drawer
closeBtn?.addEventListener('click', () => {
    drawer.classList.remove('active');
    document.body.style.overflow = "";
});

// Optional: close drawer by clicking outside
drawer.addEventListener('click', (e) => {
    if (e.target === drawer) {
        drawer.classList.remove('active');
        document.body.style.overflow = "";
    }
});




document.querySelectorAll('.mobile_has_children').forEach(function (element) {
    const plus = element.querySelector('.plus');
    plus.addEventListener('click', function () {
        const wrapper = this.closest('.mobile_has_children_wrapper');
        const childMain = wrapper.nextElementSibling;
        const vert = this.querySelector('.vert');
        const siblings = this.closest('.mobile_has_children').parentNode.querySelectorAll('.mobile_has_children');

        // Toggle active class and slide for clicked element
        childMain.classList.toggle('active');
        if (childMain.classList.contains('active')) {
            childMain.style.display = 'block';
        } else {
            childMain.style.display = 'none';
        }

        // Toggle vert class
        vert.classList.toggle('trip');

        // Close other siblings
        siblings.forEach(function (sibling) {
            if (sibling !== element) {
                const siblingChildMain = sibling.querySelector('.mobile_child_main');
                if (siblingChildMain) {
                    siblingChildMain.classList.remove('active');
                    siblingChildMain.style.display = 'none';
                }
                const siblingVert = sibling.querySelector('.vert');
                if (siblingVert) {
                    siblingVert.classList.remove('trip');
                }
            }
        });
    });
});

document.querySelectorAll('.mobile_has_grandchildren').forEach(function (element) {
    const caret = element.querySelector('.caret');
    caret.addEventListener('click', function () {
        const wrapper = this.closest('.mobile_has_grandchildren_wrapper');
        const grandchildMain = wrapper.nextElementSibling;
        const siblings =
            this.closest('.mobile_has_grandchildren').parentNode.querySelectorAll('.mobile_has_grandchildren');

        // Toggle display for clicked element
        if (grandchildMain.style.display === 'none' || !grandchildMain.style.display) {
            grandchildMain.style.display = 'block';
        } else {
            grandchildMain.style.display = 'none';
        }

        // Toggle trip class
        this.classList.toggle('trip');

        // Close other siblings
        siblings.forEach(function (sibling) {
            if (sibling !== element) {
                const siblingGrandchildMain = sibling.querySelector('.mobile_grandchild_main');
                if (siblingGrandchildMain) {
                    siblingGrandchildMain.style.display = 'none';
                }
                const siblingCaret = sibling.querySelector('.caret');
                if (siblingCaret) {
                    siblingCaret.classList.remove('trip');
                }
            }
        });
    });
});